import { takeLatest, put, select } from 'redux-saga/effects';
import * as appointmentDetails from '../requests/appointment-details-req';
import * as appointmentActions from '../requests/appointment-list-req';
import { selectCurrentAppointmentDetails } from '../selectors';

export function* appointmentDetailsWorker() {
  const currentAppointment = yield select(selectCurrentAppointmentDetails);
  yield put(
    appointmentActions.actions.setActiveAppointment(currentAppointment),
  );
}

export default function* appointmentDetailsSaga() {
  yield takeLatest(appointmentDetails.consts.SUCCEED, appointmentDetailsWorker);
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/appointment-details-saga.js